import React from "react";
import Github from '../Assets/github.png';
import mongo from '../Assets/mongo.png';
import node from '../Assets/node.png';
import next from '../Assets/next.png'
import docker from '../Assets/docker.png'
import claude from '../Assets/claude.webp'
import odoo from '../Assets/odoo.png'
import aws from '../Assets/aws.png'

import "./Skills.css";

const CodexIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="Codex logo">
    <rect width="96" height="96" rx="22" fill="#05070A" />
    <path
      d="M25 29.5L48 16L71 29.5V56.5L48 70L25 56.5V29.5Z"
      fill="none"
      stroke="#F8FAFC"
      strokeWidth="6"
      strokeLinejoin="round"
    />
    <path
      d="M48 16V70M25 29.5L48 43L71 29.5M25 56.5L48 43L71 56.5"
      fill="none"
      stroke="#00A67E"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35 81H61"
      stroke="#F8FAFC"
      strokeWidth="6"
      strokeLinecap="round"
    />
  </svg>
);

const CursorIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="Cursor logo">
    <rect width="96" height="96" rx="22" fill="#171717" />
    <path
      d="M48 15L76 31V63L48 81L20 63V31L48 15Z"
      fill="#F6F7F8"
    />
    <path
      d="M48 15L76 31L48 47L20 31L48 15Z"
      fill="#D8DADD"
    />
    <path
      d="M20 31L48 47V81L20 63V31Z"
      fill="#FFFFFF"
    />
    <path
      d="M76 31L48 47V81L76 63V31Z"
      fill="#8D9298"
    />
    <path
      d="M35 38L48 30L61 38L48 46L35 38Z"
      fill="#4B5563"
    />
  </svg>
);

const WindowsIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="Windows OS logo">
    <rect x="10" y="14" width="34" height="32" fill="#00A4EF" />
    <rect x="50" y="14" width="36" height="32" fill="#00A4EF" />
    <rect x="10" y="52" width="34" height="30" fill="#00A4EF" />
    <rect x="50" y="52" width="36" height="30" fill="#00A4EF" />
  </svg>
);

const JavaIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="Java logo">
    <path
      d="M43 12C55 22 24 32 47 43C35 32 66 24 43 12Z"
      fill="#E76F00"
    />
    <path
      d="M55 20C66 31 36 38 52 50C44 40 76 33 55 20Z"
      fill="#E76F00"
    />
    <path
      d="M26 58C39 53 64 54 70 59C64 66 35 66 26 58Z"
      fill="#5382A1"
    />
    <path
      d="M30 70C42 75 62 74 73 68"
      fill="none"
      stroke="#5382A1"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <path
      d="M24 79C39 88 67 86 79 76"
      fill="none"
      stroke="#E76F00"
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);

const TypeScriptIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="TypeScript logo">
    <rect x="10" y="10" width="76" height="76" rx="10" fill="#3178C6" />
    <path d="M24 34H57V43H45V73H35V43H24V34Z" fill="#FFFFFF" />
    <path
      d="M59 72C55 72 51 71 48 69V59C51 62 55 64 59 64C63 64 65 63 65 61C65 59 63 58 58 56C51 53 48 50 48 44C48 37 54 33 62 33C66 33 70 34 73 36V46C70 43 67 41 63 41C60 41 58 42 58 44C58 46 60 47 65 49C72 52 75 55 75 62C75 69 69 72 59 72Z"
      fill="#FFFFFF"
    />
  </svg>
);

const XmlIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="XML logo">
    <rect x="16" y="10" width="64" height="76" rx="10" fill="#F97316" />
    <path
      d="M34 33L21 48L34 63M62 33L75 48L62 63"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53 29L43 67"
      fill="none"
      stroke="#111827"
      strokeWidth="7"
      strokeLinecap="round"
    />
  </svg>
);

const KubernetesIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="Kubernetes logo">
    <path
      d="M48 7L82 27V69L48 89L14 69V27L48 7Z"
      fill="#326CE5"
    />
    <circle cx="48" cy="48" r="13" fill="#FFFFFF" />
    <path
      d="M48 18V35M48 61V78M18 48H35M61 48H78M27 27L39 39M57 57L69 69M69 27L57 39M39 57L27 69"
      stroke="#FFFFFF"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <circle cx="48" cy="48" r="5" fill="#326CE5" />
  </svg>
);

const GcpIcon = () => (
  <svg viewBox="0 0 96 96" role="img" aria-label="Google Cloud Platform logo">
    <path d="M27 66.5A18 18 0 0 1 30 31a24 24 0 0 1 43.5 7.5A15 15 0 1 1 70 67H27Z" fill="#FFFFFF" />
    <path d="M30 31a24 24 0 0 1 34.5-2.5L56 38a11 11 0 0 0-17 7.5H27A18 18 0 0 1 30 31Z" fill="#EA4335" />
    <path d="M64.5 28.5A24 24 0 0 1 73.5 38.5A15 15 0 0 1 70 67H55V55h15a3 3 0 1 0 0-6h-4.5Z" fill="#4285F4" />
    <path d="M27 45.5H39A11 11 0 0 0 45 55v12H27a18 18 0 0 1 0-21.5Z" fill="#FBBC04" />
    <path d="M45 55a11 11 0 0 0 19.5 0H70v12H45Z" fill="#34A853" />
  </svg>
);

export const Skills = () => {
  return (
    <div name='skills' className="Skills bg-black text-white">
      <div className="heading">
        <div className="headings flex items-baseline">
          <h1 className="px-5 text-2xl lg:px-20 lg:text-4xl text-black font-semibold">
            Skills
          </h1>
          <h4 className="text-lg px-4 worked">
            These are the technologies I've worked with...
          </h4>
        </div>
      </div>

      <div className="skilldiv flex gap-10 justify-between py-4">
        <div className="div-skill card mr-5 mt-5 mb-5">
          <h2 className="text-base font-semibold py-5 px-5 lg:px-9 lg:text-xl">
            UI/UX Designing,  Front-End Development, AI Tools
          </h2>
          <div className="flex justify-center flex-wrap gap-5">
            <div className="figma python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="80"
                width="80"
                viewBox="0 0 66 98"
                fill="none"

              >
                <g height="80"
                  width="80">
                  <path
                    d="M16.3368 98C25.3528 98 32.6701 90.6826 32.6701 81.6666V65.3333H16.3368C7.32075 65.3333 0.00341797 72.6506 0.00341797 81.6666C0.00341797 90.6826 7.32075 98 16.3368 98Z"
                    fill="#0ACF83"
                  />
                  <path
                    d="M0.00341797 49C0.00341797 39.984 7.32075 32.6667 16.3368 32.6667H32.6701V65.3334H16.3368C7.32075 65.3334 0.00341797 58.016 0.00341797 49Z"
                    fill="#A259FF"
                  />
                  <path
                    d="M0.00341797 16.3333C0.00341797 7.31733 7.32075 0 16.3368 0H32.6701V32.6667H16.3368C7.32075 32.6667 0.00341797 25.3493 0.00341797 16.3333Z"
                    fill="#F24E1E"
                  />
                  <path
                    d="M32.6699 0H49.0033C58.0193 0 65.3366 7.31733 65.3366 16.3333C65.3366 25.3493 58.0193 32.6667 49.0033 32.6667H32.6699V0Z"
                    fill="#FF7262"
                  />
                  <path
                    d="M65.3366 49C65.3366 58.016 58.0193 65.3334 49.0033 65.3334C39.9873 65.3334 32.6699 58.016 32.6699 49C32.6699 39.984 39.9873 32.6667 49.0033 32.6667C58.0193 32.6667 65.3366 39.984 65.3366 49Z"
                    fill="#1ABCFE"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_30_4">
                    <rect width="65.34" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">Figma</h2>
            </div>

            <div className="Canva python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <g clip-path="url(#clip0_31_10)">
                  <path
                    d="M45.4706 0.116346C45.1 0.155393 43.9432 0.29244 42.9226 0.412643C38.8081 0.881971 34.1424 2.11769 30.0478 3.84264C15.2292 10.0343 4.0763 23.6187 0.999252 39.2C0.274971 42.9056 0.098877 44.7263 0.098877 49C0.098877 54.5086 0.646299 58.31 2.09716 63.1135C6.84021 78.8318 19.1882 91.1599 34.9471 95.9213C39.6901 97.3538 43.5121 97.9012 49.0001 97.9012C54.5088 97.9012 58.3101 97.3538 63.1136 95.9029C78.8319 91.1599 91.16 78.8119 95.9214 63.053C97.3539 58.31 97.9013 54.488 97.9013 49C97.9013 46.6671 97.785 44.0027 97.6472 43.0212C96.0593 31.693 91.3935 22.1671 83.6148 14.3853C75.8506 6.6632 66.3645 1.97988 55.2706 0.391971C53.7424 0.176065 46.6665 -0.0214664 45.4706 0.116346ZM29.4973 30.9863C30.5386 31.3003 31.0255 31.5943 31.7314 32.2994C33.1042 33.6928 33.4181 34.4562 33.4181 36.5524C33.4181 38.1227 33.3584 38.416 32.8891 39.2383C31.9856 40.7664 29.8893 42.1783 28.4393 42.2165C27.4187 42.238 27.4608 41.7863 28.5771 40.611C30.0662 39.0622 30.2813 38.4749 30.2813 36.1604C30.263 33.9271 29.9881 33.1638 28.9499 32.536C28.0863 32.0069 27.1469 32.046 25.7741 32.6914C22.2063 34.3987 18.3453 40.082 16.8377 45.9045C14.8372 53.6657 18.3843 59.8772 24.2253 58.8183C25.9295 58.5044 29.1444 56.8599 30.5386 55.5644C31.6932 54.5086 31.6932 54.488 31.8095 53.1757C32.0668 50.4294 34.0046 47.6869 36.5947 46.4129C37.7875 45.8234 38.0838 45.7667 39.6901 45.7667C41.2183 45.7667 41.5713 45.8448 42.3162 46.2544C44.6873 47.6096 44.1973 50.764 41.631 50.764C40.1418 50.764 39.3762 49.9983 40.4557 49.5895C41.5146 49.1975 41.1195 47.726 39.8876 47.3937C38.4368 47.0201 36.7892 48.0008 35.751 49.882C34.4953 52.1559 34.4379 54.8616 35.6315 56.0943C36.7892 57.3292 38.2392 56.3515 39.3578 53.5455C39.9443 52.1161 40.7873 51.3504 41.7688 51.3504C42.6301 51.3504 42.7886 51.8803 42.4142 53.4888C41.8645 55.9771 42.2381 56.6233 43.787 55.8607C44.2953 55.6242 45.1391 55.0775 45.6474 54.6855L46.6075 53.9199L47.2568 50.5282C47.9627 46.7268 48.2345 46.2154 49.6853 45.9436C51.0788 45.6863 51.3927 46.3739 50.8813 48.5483L50.6056 49.7656L51.6262 48.7243C54.0364 46.2544 56.9971 45.0402 58.0169 46.06C58.5643 46.6074 58.5046 47.2949 57.7213 49.7235C57.35 50.8811 56.8386 52.7056 56.6058 53.743C56.2529 55.3103 56.2314 55.6839 56.4297 55.9388C57.0576 56.683 58.977 55.9174 60.682 54.2514L61.6812 53.2737L61.8006 51.0963C61.917 48.5873 62.1505 47.6869 62.8173 46.8823C63.4452 46.1381 64.5821 45.5906 65.1893 45.7461C65.7964 45.9045 65.7964 46.491 65.249 48.2167C64.4833 50.5879 64.5637 56.0552 65.3477 56.0552C65.6616 56.0552 67.2672 54.3708 68.2877 52.9598L69.0503 51.9185L68.4432 51.2938C67.3843 50.176 67.1301 49.4517 67.1301 47.6272C67.1301 46.2965 67.2289 45.8058 67.5604 45.1565C68.1109 44.1398 68.9722 43.3956 69.992 43.0993C71.0685 42.767 72.4022 43.3144 72.9496 44.2952C73.5001 45.2943 73.3631 47.5284 72.6564 49.0597L72.148 50.1752H72.8333C73.775 50.1752 74.1463 49.9417 75.833 48.3538C76.715 47.5108 77.7348 46.7843 78.4973 46.4313C81.4971 45.0225 85.0266 45.7461 85.6123 47.9021C86.1023 49.6278 85.0266 50.8421 83.1424 50.7043C81.7903 50.6063 81.5361 50.2525 82.3201 49.5895C83.7312 48.4104 82.3201 46.9037 80.3012 47.4511C79.2033 47.7466 77.9683 48.9793 77.3229 50.4118C76.0274 53.2737 76.715 56.644 78.5754 56.644C79.3204 56.644 80.6357 55.1732 81.1441 53.743C81.7513 52.0954 83.0253 51.058 83.9853 51.4308C84.5152 51.6261 84.5542 52.1551 84.2219 53.8211C83.8483 55.6456 83.7909 57.3506 84.0841 58.1339C84.2013 58.4263 84.5542 58.9768 84.8888 59.3482C85.5135 60.0533 85.535 60.3083 85.0052 60.6428C84.751 60.8189 84.4156 60.7416 83.5941 60.2906C82.4572 59.7011 81.4764 58.6423 81.1234 57.6431L80.9083 57.0566L80.1243 57.6431C79.6726 57.957 78.9674 58.31 78.5571 58.4263C76.9301 58.8574 74.9295 57.7419 73.9909 55.8607C73.6165 55.1334 73.5001 52.9988 73.775 52.1758C73.9312 51.7241 73.9312 51.7241 73.3026 52.038C72.9711 52.2148 72.2652 52.4093 71.7177 52.469C70.8143 52.5686 70.6765 52.6666 69.7769 53.8027C68.5029 55.3876 66.2473 57.5267 65.3263 57.9785C63.3678 58.9562 62.7216 58.6813 62.2102 56.6616L61.8573 55.3103L61.0135 56.0552C59.9371 56.9969 57.7811 58.1339 56.5453 58.4087C55.3701 58.6629 54.1145 58.2893 53.6053 57.5053C52.8436 56.3301 53.0977 53.8418 54.3113 50.4891C55.2116 48.0008 54.5662 47.9625 52.2931 50.3337C50.6064 52.1161 49.8821 53.3901 49.4128 55.37C48.9228 57.428 48.3332 58.1722 47.0026 58.4861C46.1979 58.6629 45.8235 58.1722 45.9828 57.0957L46.0992 56.2313L45.3542 56.7427C44.2953 57.467 42.9616 58.1339 42.0406 58.3881C41.1195 58.6423 39.9052 58.3697 39.612 57.8583C39.083 56.9586 39.083 56.9586 38.2607 57.6041C36.4753 59.0549 33.9273 58.6423 32.6349 56.7221L32.2214 56.1149L30.9298 57.3108C27.2035 60.7209 22.5409 62.2491 19.0902 61.1903C14.6993 59.8596 12.2708 56.0943 12.3098 50.666C12.3282 45.217 14.7384 39.4748 18.797 35.2218C21.0908 32.8292 23.2468 31.4174 25.4426 30.8883C27.0274 30.4963 27.9906 30.5163 29.4973 30.9863Z"
                    fill="#00C4CC"
                  />
                  <path
                    d="M69.2264 44.9238C68.7954 45.3541 68.9539 47.0798 69.5021 48.1777C69.7769 48.7458 70.0701 49.1975 70.1681 49.1975C70.2462 49.1975 70.4223 48.7458 70.5601 48.1953C71.0501 46.1588 70.1681 43.9813 69.2264 44.9238Z"
                    fill="#00C4CC"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_31_10">
                    <rect width="98" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">Canva</h2>
            </div>


            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <path
                  d="M18.0748 83.3031L11.1934 6.125H86.8065L79.9159 83.2908L48.954 91.875L18.0748 83.3031Z"
                  fill="#E44F26"
                />
                <path
                  d="M49 85.3151L74.0206 78.3786L79.9067 12.4368H49V85.3151Z"
                  fill="#F1662A"
                />
                <path
                  d="M49 41.059H36.4744L35.6108 31.3661H49V21.9H25.2656L25.4923 24.4418L27.8167 50.5251H49V41.059ZM49 65.6417L48.9571 65.6539L38.416 62.8088L37.7423 55.2598H28.2393L29.5654 70.119L48.9571 75.5029L49 75.4907V65.6417Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M48.9663 41.059V50.5251H60.6222L59.5258 62.8027L48.9663 65.6508V75.4998L68.3734 70.119L68.5142 68.5204L70.7376 43.6008L70.9704 41.059H48.9663ZM48.9663 21.9V31.3661H71.8309L72.0208 29.2408L72.4526 24.4418L72.6792 21.9H48.9663Z"
                  fill="white"
                />
              </svg>
              <h2 className="text-white mt-2">HTML5</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <path
                  d="M18.0749 83.3031L11.1965 6.125H86.8035L79.916 83.2908L48.9541 91.875L18.0749 83.3031Z"
                  fill="#1572B6"
                />
                <path
                  d="M49 85.3151L74.0206 78.3786L79.9067 12.4368H49V85.3151Z"
                  fill="#33A9DC"
                />
                <path
                  d="M49 40.3975H61.5256L62.3892 30.7047H49V21.2385H72.7344L72.5078 23.7773L70.1833 49.8637H49V40.3975Z"
                  fill="white"
                />
                <path
                  d="M49.0583 64.9802L49.0154 64.9924L38.4743 62.1443L37.8005 54.5952H28.2976L29.6237 69.4575L49.0124 74.8414L49.0583 74.8292V64.9802Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M60.7201 49.4624L59.5809 62.1381L49.0244 64.9862V74.8352L68.4284 69.4575L68.5724 67.8588L70.2169 49.4624H60.7201Z"
                  fill="white"
                />
                <path
                  d="M49.0337 21.2385V30.7047H26.1691L25.9792 28.5762L25.5474 23.7773L25.3208 21.2385H49.0337ZM49.0001 40.3975V49.8637H38.5906L38.4007 47.7352L37.972 42.9363L37.7454 40.3975H49.0001Z"
                  fill="#EBEBEB"
                />
              </svg>
              <h2 className="text-white mt-2">CSS3</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <g clip-path="url(#clip0_29_18)">
                  <path
                    d="M75.0312 0H22.9688C10.2835 0 0 10.2835 0 22.9688V75.0312C0 87.7165 10.2835 98 22.9688 98H75.0312C87.7165 98 98 87.7165 98 75.0312V22.9688C98 10.2835 87.7165 0 75.0312 0Z"
                    fill="#F0DB4F"
                  />
                  <path
                    d="M25.768 81.8959L33.2673 77.3572C34.7143 79.9225 36.0304 82.093 39.1875 82.093C42.2136 82.093 44.1215 80.9094 44.1215 76.3049V44.9916H53.3312V76.435C53.3312 85.9736 47.7399 90.3154 39.5821 90.3154C32.2149 90.3154 27.9385 86.5 25.7676 81.8951M58.3334 80.909L65.832 76.5675C67.8061 79.7912 70.3718 82.1592 74.9104 82.1592C78.7266 82.1592 81.1598 80.2513 81.1598 77.6198C81.1598 74.4624 78.66 73.3438 74.4498 71.5025L72.148 70.5152C65.5035 67.687 61.0958 64.1345 61.0958 56.6352C61.0958 49.7278 66.3587 44.4648 74.5819 44.4648C80.4367 44.4648 84.6468 46.5045 87.6726 51.8328L80.5021 56.4377C78.923 53.6091 77.2134 52.4909 74.5819 52.4909C71.8846 52.4909 70.1742 54.2013 70.1742 56.4377C70.1742 59.2004 71.8846 60.319 75.8314 62.0298L78.1337 63.0163C85.9618 66.3717 90.3695 69.7917 90.3695 77.4882C90.3695 85.7776 83.8571 90.3162 75.1079 90.3162C66.5563 90.3162 61.0304 86.2377 58.3334 80.909Z"
                    fill="#323330"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_29_18">
                    <rect width="98" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">JavaScript</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg
                className="rotating-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 88"
                fill="none"
              >
                <g clip-path="url(#clip0_29_22)">
                  <path
                    d="M80.5741 28.2594C79.5312 27.9016 78.4795 27.5701 77.4199 27.2653C77.5979 26.538 77.7617 25.8195 77.9072 25.1136C80.2951 13.5222 78.734 4.18389 73.4021 1.10927C68.2898 -1.83825 59.9292 1.23521 51.4855 8.58374C50.6533 9.30926 49.8396 10.0557 49.0452 10.8223C48.5133 10.3125 47.9721 9.81265 47.4217 9.32292C38.5723 1.46566 29.7021 -1.84591 24.3759 1.23751C19.2683 4.19422 17.7559 12.9729 19.9056 23.9583C20.1195 25.0463 20.361 26.1287 20.6299 27.2044C19.3743 27.5612 18.1628 27.9409 17.0033 28.3452C6.628 31.9626 0.00219727 37.6314 0.00219727 43.5115C0.00219727 49.5846 7.1153 55.676 17.9216 59.3696C18.7977 59.6678 19.6811 59.9441 20.5709 60.1983C20.2819 61.3569 20.0254 62.5234 19.8015 63.6963C17.752 74.4912 19.3525 83.0623 24.4464 86.0003C29.7075 89.0343 38.5378 85.9161 47.1358 78.3999C47.833 77.7888 48.5148 77.1605 49.1807 76.5154C50.041 77.3455 50.9244 78.1515 51.8296 78.9323C60.1585 86.099 68.384 88.993 73.4729 86.047C78.729 83.0041 80.4375 73.7964 78.2195 62.5939C78.0448 61.7162 77.8489 60.8429 77.632 59.9748C78.2521 59.791 78.8607 59.6019 79.4541 59.4052C90.6883 55.6833 97.9978 49.6657 97.9978 43.5115C97.9978 37.61 91.158 31.9029 80.5741 28.2594ZM78.1376 55.4318C77.6017 55.609 77.052 55.7801 76.4916 55.9466C75.2513 52.0203 73.5778 47.8455 71.5294 43.5318C73.484 39.3211 75.0933 35.1995 76.2987 31.2988C77.3012 31.589 78.2739 31.8948 79.2117 32.2175C88.2802 35.3396 93.8116 39.955 93.8116 43.5115C93.8116 47.2997 87.8377 52.2174 78.1376 55.4318ZM74.1129 63.4069C75.0936 68.3603 75.2334 72.839 74.5838 76.3404C74.0004 79.4866 72.8267 81.584 71.3752 82.4242C68.2872 84.2119 61.6828 81.8883 54.5601 75.759C53.7181 75.0329 52.8964 74.2837 52.0961 73.512C54.8575 70.4921 57.6171 66.9815 60.3105 63.0823C65.0479 62.662 69.5236 61.9745 73.5824 61.0363C73.7779 61.8222 73.9548 62.6126 74.1129 63.4069ZM33.411 82.1153C30.3939 83.1806 27.9907 83.2112 26.538 82.3737C23.4469 80.591 22.1618 73.7087 23.9147 64.4772C24.123 63.3864 24.3616 62.3015 24.6301 61.2238C28.6441 62.1119 33.0872 62.7504 37.8358 63.1355C40.5475 66.9508 43.3867 70.4576 46.2481 73.5284C45.64 74.1168 45.0175 74.6902 44.3812 75.2479C40.5789 78.5714 36.7689 80.9294 33.411 82.1153ZM19.2759 55.4084C14.4975 53.775 10.5513 51.6524 7.84644 49.3361C5.41569 47.2549 4.18883 45.1882 4.18883 43.5115C4.18883 39.9431 9.50854 35.3917 18.3814 32.2983C19.4582 31.9232 20.5851 31.5691 21.7545 31.2368C22.981 35.2255 24.5895 39.3961 26.5307 43.6133C24.5643 47.893 22.9328 52.1302 21.6944 56.166C20.8822 55.9333 20.0758 55.6807 19.2759 55.4084ZM24.0142 23.1541C22.1726 13.7423 23.3956 6.64258 26.4736 4.86067C29.7519 2.96277 37.0013 5.66875 44.6423 12.4534C45.1405 12.8968 45.6307 13.3492 46.1126 13.8104C43.2654 16.8678 40.4522 20.3486 37.7646 24.1413C33.1557 24.5685 28.744 25.2545 24.6879 26.1736C24.438 25.173 24.2134 24.1659 24.0142 23.1541ZM66.2851 33.5921C65.3271 31.9373 64.3335 30.3033 63.3051 28.6912C66.4317 29.0866 69.4275 29.6115 72.2407 30.253C71.3962 32.9601 70.3435 35.7902 69.1044 38.6917C68.1987 36.9733 67.2587 35.2731 66.2851 33.5921ZM49.0471 16.8024C50.9779 18.8943 52.9118 21.2298 54.8139 23.7639C50.9553 23.5816 47.0903 23.5809 43.2317 23.7616C45.1357 21.2508 47.086 18.9184 49.0471 16.8024ZM31.6984 33.6209C30.737 35.2882 29.8146 36.9779 28.932 38.6883C27.7131 35.797 26.67 32.954 25.8183 30.2086C28.6142 29.5831 31.5958 29.0717 34.7026 28.6836C33.6627 30.3055 32.661 31.9519 31.6984 33.6209ZM34.7918 58.6373C31.5821 58.279 28.5557 57.794 25.7605 57.1854C26.6256 54.391 27.6917 51.4874 28.9369 48.5342C29.823 50.2459 30.7493 51.9365 31.7149 53.6047C32.7079 55.3196 33.736 56.9993 34.7918 58.6373ZM49.1627 70.5154C47.1783 68.3749 45.1992 66.0065 43.2665 63.4594C45.143 63.5329 47.0558 63.5704 49 63.5704C50.9974 63.5704 52.9719 63.5256 54.9153 63.4391C53.0071 66.0321 51.0805 68.4039 49.1627 70.5154ZM69.1439 48.3834C70.4538 51.3692 71.5578 54.2574 72.4344 57.0039C69.5932 57.6524 66.5255 58.1745 63.2932 58.5623C64.329 56.9203 65.332 55.2579 66.3016 53.576C67.2874 51.8664 68.2351 50.1351 69.1439 48.3834ZM62.6754 51.4844C61.191 54.063 59.6231 56.5927 57.9743 59.0695C54.9875 59.281 51.9942 59.3861 49 59.3845C45.9503 59.3845 42.984 59.2896 40.1276 59.1043C38.4357 56.6333 36.8379 54.0992 35.3377 51.5074C33.8444 48.9293 32.4501 46.2954 31.1568 43.6114C32.4468 40.9268 33.8373 38.2917 35.3254 35.7117L35.325 35.7121C36.8126 33.1313 38.3976 30.608 40.0767 28.1476C42.9909 27.9272 45.9794 27.8123 48.9996 27.8123C52.0337 27.8123 55.0264 27.9283 57.9398 28.1503C59.6019 30.607 61.1768 33.1217 62.6616 35.6895C64.1547 38.2639 65.5636 40.8861 66.8861 43.5521C65.5772 46.2453 64.1727 48.8911 62.6754 51.4844ZM71.3112 4.73588C74.5926 6.62842 75.8688 14.2602 73.8071 24.2684C73.6754 24.9069 73.5276 25.5573 73.3668 26.2168C69.3008 25.2782 64.886 24.5804 60.2638 24.1467C57.5712 20.3122 54.781 16.8261 51.9801 13.8081C52.7141 13.1005 53.4657 12.4113 54.234 11.741C61.4688 5.4452 68.2305 2.95932 71.3112 4.73588ZM49 34.7608C53.8328 34.7608 57.7507 38.6787 57.7507 43.5115C57.7507 48.3443 53.8328 52.2622 49 52.2622C44.1672 52.2622 40.2493 48.3443 40.2493 43.5115C40.2493 38.6787 44.1672 34.7608 49 34.7608Z"
                    fill="#00D8FF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_29_22">
                    <rect width="98" height="87.2774" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">React.JS</h2>
            </div>
            
            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src={next} alt="Nodejs icon" />
              <h2 className="text-white mt-2">Next.JS</h2>
            </div>
            
            
            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 80 98"
                fill="none"
              >
                <path
                  d="M48.7463 0.000305176L0.00439453 48.7422L15.0908 63.8286L78.9197 0.000305176H48.7463ZM48.4065 44.9492L22.3088 71.0469L37.4521 86.4165L52.5108 71.3579L78.9197 44.9492H48.4065Z"
                  fill="#47C5FB"
                />
                <path
                  d="M37.4521 86.4165L48.916 97.8804H78.9194L52.5104 71.3579L37.4521 86.4165Z"
                  fill="#00569E"
                />
                <path
                  d="M22.1392 71.2166L37.2259 56.1299L52.5105 71.3579L37.4522 86.4165L22.1392 71.2166Z"
                  fill="#00B5F8"
                />
                <path
                  d="M37.4521 86.4165L49.9912 82.2557L51.2368 72.6316L37.4521 86.4165Z"
                  fill="url(#paint0_linear_29_63)"
                  fill-opacity="0.8"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_29_63"
                    x1="91.9289"
                    y1="444.728"
                    x2="1083.67"
                    y2="802.102"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop />
                    <stop offset="1" stop-opacity="0" />
                  </linearGradient>
                </defs>
              </svg>
              <h2 className="text-white mt-2">Flutter</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <g clip-path="url(#clip0_29_26)">
                  <path
                    d="M49.0032 19.6015C35.9362 19.6015 27.7724 26.1323 24.5032 39.1992C29.4016 32.6677 35.1201 30.2184 41.6516 31.8515C45.381 32.781 48.0461 35.4852 50.9976 38.4818C55.8012 43.3565 61.3611 49 73.5032 49C86.5693 49 94.734 42.4684 98.0032 29.3984C93.1039 35.9338 87.3863 38.383 80.8539 36.75C77.1254 35.8197 74.4633 33.1163 71.508 30.1197C66.7075 25.2449 61.149 19.6015 49.0032 19.6015ZM24.5032 49C11.437 49 3.27239 55.5315 0.00317383 68.6015C4.90164 62.0661 10.6193 59.6169 17.1516 61.25C20.881 62.1802 23.5461 64.8836 26.4976 67.8803C31.3012 72.755 36.8611 78.3984 49.0032 78.3984C62.0693 78.3984 70.234 71.8677 73.5032 58.8007C68.6039 65.3323 62.8863 67.7815 56.3539 66.1484C52.6254 65.219 49.9633 62.5148 47.008 59.5181C42.2075 54.6434 36.649 49 24.5032 49Z"
                    fill="#38BDF8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_29_26">
                    <rect width="98" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">TailwindCSS</h2>
            </div>

            


            {/* <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 98"
                fill="none"
              >
                <g clip-path="url(#clip0_31_14)">
                  <path
                    d="M83.6959 0H16.6639C7.46284 0 0.00390625 7.45894 0.00390625 16.66V81.1832C0.00390625 90.3843 7.46284 97.8432 16.6639 97.8432H83.6959C92.897 97.8432 100.356 90.3843 100.356 81.1832V16.66C100.356 7.45894 92.897 0 83.6959 0Z"
                    fill="#330000"
                  />
                  <path
                    d="M48.6332 58.7177H33.0825L29.9183 68.5463C29.8753 68.7256 29.771 68.8842 29.6235 68.9948C29.476 69.1055 29.2946 69.1612 29.1104 69.1523H21.234C20.7851 69.1523 20.6279 68.9054 20.7628 68.4115L34.2268 29.6356C34.3612 29.2318 34.4961 28.772 34.6306 28.2558C34.807 27.3573 34.8971 26.4447 34.8999 25.5294C34.8907 25.4654 34.8966 25.4001 34.917 25.3387C34.9374 25.2774 34.9719 25.2216 35.0176 25.1758C35.0633 25.1301 35.119 25.0956 35.1804 25.0751C35.2417 25.0546 35.307 25.0487 35.371 25.0578H46.075C46.3886 25.0578 46.5681 25.1703 46.6136 25.395L61.8949 68.4789C62.0298 68.9281 61.8949 69.1527 61.4912 69.1523H52.7394C52.5891 69.169 52.4379 69.1304 52.314 69.0437C52.1901 68.9569 52.1021 68.8281 52.0663 68.6812L48.6332 58.7177ZM35.5059 50.2356H46.1424L45.9907 49.735L45.7473 48.9424L45.5736 48.3858L45.2965 47.5092L44.7073 45.6641L44.1891 44.0283L42.8433 39.7672C42.5084 38.708 42.1869 37.6446 41.879 36.5771L41.6328 35.7108L41.3451 34.6865L40.9061 33.0989L40.8238 32.7998H40.7567C40.4199 34.4157 40.0097 36.0154 39.5274 37.594L38.5286 40.8068L37.979 42.5818L37.4243 44.3787C37.324 44.7033 37.2244 45.0244 37.1245 45.3415L36.8265 46.2815L36.5302 47.1996L36.2354 48.0949L35.9422 48.9679C35.845 49.2552 35.7478 49.5386 35.6509 49.8185L35.5059 50.2356ZM70.9823 32.1938C70.2957 32.2214 69.611 32.1037 68.973 31.8485C68.335 31.5933 67.758 31.2063 67.2798 30.7128C66.8029 30.1979 66.4325 29.5938 66.1899 28.9353C65.9472 28.2768 65.8371 27.5768 65.8659 26.8755C65.8415 26.1813 65.9638 25.4898 66.2248 24.8461C66.4858 24.2024 66.8796 23.6209 67.3806 23.1398C68.3469 22.2122 69.6338 21.693 70.9733 21.6906L71.1167 21.6921C72.7326 21.6921 74.0007 22.1743 74.9207 23.1394C75.3851 23.6408 75.7459 24.2289 75.9827 24.87C76.2195 25.5111 76.3275 26.1926 76.3005 26.8755C76.3288 27.5796 76.2152 28.2821 75.9666 28.9413C75.718 29.6006 75.3394 30.2032 74.8533 30.7132C74.3625 31.1969 73.78 31.5776 73.1399 31.8327C72.4998 32.0879 71.8151 32.2124 71.1261 32.1989L70.9823 32.1938ZM66.3371 68.4789V36.3004C66.3371 35.8966 66.5158 35.6944 66.8757 35.6944H75.1563C75.515 35.6944 75.6945 35.8962 75.6949 36.3004V68.4789C75.6949 68.9281 75.5154 69.1527 75.1563 69.1523H66.9431C66.5605 69.1523 66.359 68.9509 66.339 68.5479L66.3371 68.4789Z"
                    fill="#FF9A00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_31_14">
                    <rect width="100.36" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">Adobe Illustrator</h2>
            </div> */}

            <div className="python flex flex-col items-center">
              <svg
                className="rotating-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <path
                  d="M37.5259 57.0442V27.6442L60.3721 14.455C73.0305 7.14582 95.693 25.1737 86.1788 41.6704"
                  stroke="#00A67E"
                  stroke-width="2.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M37.5259 42.7525L62.9855 28.0525L85.8317 41.2417C98.4901 48.5508 94.2026 77.1954 75.1538 77.1954"
                  stroke="#00A67E"
                  stroke-width="2.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M49.8984 35.6067L75.358 50.3067V76.7054C75.358 91.3238 48.408 101.94 38.8938 85.4438"
                  stroke="#00A67E"
                  stroke-width="2.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M62.2709 43.2833V72.1525L39.4246 85.3417C26.7663 92.6508 4.10378 74.6229 13.6179 58.1262"
                  stroke="#00A67E"
                  stroke-width="2.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M62.2708 57.0442L36.8112 71.7442L13.965 58.555C1.28623 51.2254 5.57373 22.6013 24.6225 22.6013"
                  stroke="#00A67E"
                  stroke-width="2.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M49.8983 64.19L24.4387 49.49V23.0912C24.4387 8.47289 51.3887 -2.14378 60.9029 14.3529"
                  stroke="#00A67E"
                  stroke-width="2.04167"
                  stroke-linejoin="round"
                />
              </svg>
              <h2 className="text-white mt-2">ChatGPT</h2>
            </div>

            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src={claude} alt="Claude logo" />
              <h2 className="text-white mt-2">Claude</h2>
            </div>
            <div className="python flex flex-col items-center">
              <CodexIcon />
              <h2 className="text-white mt-2">Codex</h2>
            </div>

            {/* <div className="python flex flex-col items-center">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Adobe_Firefly_Logo.svg/1200px-Adobe_Firefly_Logo.svg.png"
                alt="Adobe Firefly AI"
              />
              <h2 className="text-white mt-2">Adobe Firefly AI</h2>
            </div> */}

            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <g clip-path="url(#clip0_31_50)">
                  <path
                    d="M75.0312 0H22.9688C10.2835 0 0 10.2835 0 22.9688V75.0312C0 87.7165 10.2835 98 22.9688 98H75.0312C87.7165 98 98 87.7165 98 75.0312V22.9688C98 10.2835 87.7165 0 75.0312 0Z"
                    fill="#0073AA"
                  />
                  <path
                    d="M16.1602 48.9977C16.1602 61.9961 23.7142 73.2293 34.668 78.5527L19.0033 35.6333C17.1255 39.8383 16.1567 44.3924 16.1602 48.9977ZM71.168 47.3405C71.168 43.2823 69.7103 40.4717 68.46 38.2839C66.7952 35.579 65.2348 33.2882 65.2348 30.5833C65.2348 27.5644 67.5244 24.7546 70.7492 24.7546C70.8951 24.7546 71.0329 24.7726 71.1749 24.7806C65.3324 19.4281 57.5487 16.16 48.999 16.16C37.5268 16.16 27.4332 22.0462 21.5617 30.9619C22.3319 30.9848 23.0581 31.0013 23.6748 31.0013C27.1098 31.0013 32.4266 30.584 32.4266 30.584C34.1968 30.4799 34.4058 33.08 32.6372 33.2894C32.6372 33.2894 30.8583 33.4988 28.8787 33.6025L40.837 69.1727L48.0236 47.6192L42.9073 33.6014C41.1391 33.4976 39.4639 33.2882 39.4639 33.2882C37.6941 33.1845 37.9016 30.4788 39.6714 30.5833C39.6714 30.5833 45.0943 30.9998 48.321 30.9998C51.7556 30.9998 57.0729 30.5833 57.0729 30.5833C58.8445 30.4788 59.0524 33.0788 57.2834 33.2882C57.2834 33.2882 55.5007 33.4976 53.525 33.6014L65.3925 68.902L68.6679 57.9567C70.0877 53.4142 71.168 50.1519 71.168 47.3405Z"
                    fill="white"
                  />
                  <path
                    d="M49.5755 51.8703L39.7227 80.5009C42.735 81.3881 45.8591 81.8387 48.9994 81.8388C52.7135 81.8401 56.4008 81.2107 59.9041 79.9772C59.813 79.8336 59.7349 79.6822 59.6706 79.5247L49.5755 51.8703ZM77.814 33.2427C77.9634 34.3619 78.0373 35.4899 78.0353 36.6191C78.0353 39.9515 77.4128 43.6977 75.5382 48.3818L65.5074 77.3833C75.2702 71.6901 81.837 61.1133 81.837 48.9985C81.8374 43.2888 80.3793 37.9199 77.814 33.2427Z"
                    fill="white"
                  />
                  <path
                    d="M48.9992 10.7188C27.8917 10.7188 10.7188 27.8906 10.7188 48.9977C10.7188 70.1075 27.8917 87.2786 48.9992 87.2786C70.1056 87.2786 87.2812 70.1075 87.2812 48.9977C87.2805 27.8906 70.1056 10.7188 48.9992 10.7188ZM48.9992 85.5241C28.8595 85.5241 12.4739 69.1382 12.4739 48.9977C12.4739 28.8583 28.8591 12.4739 48.9992 12.4739C69.1379 12.4739 85.5222 28.8583 85.5222 48.9977C85.5222 69.1382 69.1379 85.5241 48.9992 85.5241Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_31_50">
                    <rect width="98" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">WordPress</h2>
            </div>

            {/* <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <g clip-path="url(#clip0_31_56)">
                  <path
                    d="M75.0312 0H22.9688C10.2835 0 0 10.2835 0 22.9688V75.0312C0 87.7165 10.2835 98 22.9688 98H75.0312C87.7165 98 98 87.7165 98 75.0312V22.9688C98 10.2835 87.7165 0 75.0312 0Z"
                    fill="#4353FF"
                  />
                  <path
                    d="M64.7355 39.5966C64.7355 39.5966 59.447 56.1655 59.0561 57.5723C58.8999 56.1915 55.0442 26.4141 55.0442 26.4141C46.0301 26.4141 41.2366 32.8227 38.6832 39.5966C38.6832 39.5966 32.2485 56.2175 31.7275 57.5983C31.7015 56.2956 30.7375 39.7528 30.7375 39.7528C30.1901 31.4419 22.6089 26.4141 16.4609 26.4141L23.8599 71.5101C33.2905 71.4841 38.3708 65.1015 41.0279 58.302C41.0279 58.302 46.6813 43.6345 46.916 42.9833C46.968 43.6085 50.9799 71.5101 50.9799 71.5101C60.4369 71.5101 65.5432 65.5444 68.2784 59.0052L81.5391 26.4141C72.1862 26.4141 67.2625 32.7967 64.7355 39.5966Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_31_56">
                    <rect width="98" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">WebFlow</h2>
            </div>*/}
          </div>
        </div>


        {/* Backend */}
        <div className="div-skill card mr-5 mt-5 mb-5">
          <h2 className="text-base font-semibold py-5 px-5 lg:px-9 lg:text-xl">
            DSA, Back-End Development, Database, Cloud Technologies
          </h2>
          <div className="flex justify-center flex-wrap">
            <div className="python flex flex-col items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" preserveAspectRatio="xMinYMin meet" viewBox="0 0 256 288" id="c">
                <path fill="#5C8DBC" d="M255.569 84.72c-.002-4.83-1.035-9.098-3.124-12.761-2.052-3.602-5.125-6.621-9.247-9.008-34.025-19.619-68.083-39.178-102.097-58.817-9.17-5.294-18.061-5.101-27.163.269C100.395 12.39 32.59 51.237 12.385 62.94 4.064 67.757.015 75.129.013 84.711 0 124.166.013 163.62 0 203.076c.002 4.724.991 8.909 2.988 12.517 2.053 3.711 5.169 6.813 9.386 9.254 20.206 11.703 88.02 50.547 101.56 58.536 9.106 5.373 17.997 5.565 27.17.269 34.015-19.64 68.075-39.198 102.105-58.817 4.217-2.44 7.333-5.544 9.386-9.252 1.994-3.608 2.985-7.793 2.987-12.518 0 0 0-78.889-.013-118.345"></path><path fill="#1A4674" d="M128.182 143.509L2.988 215.593c2.053 3.711 5.169 6.813 9.386 9.254 20.206 11.703 88.02 50.547 101.56 58.536 9.106 5.373 17.997 5.565 27.17.269 34.015-19.64 68.075-39.198 102.105-58.817 4.217-2.44 7.333-5.544 9.386-9.252l-124.413-72.074"></path><path fill="#1A4674" d="M91.101 164.861c7.285 12.718 20.98 21.296 36.69 21.296 15.807 0 29.58-8.687 36.828-21.541l-36.437-21.107-37.081 21.352"></path><path fill="#1B598E" d="M255.569 84.72c-.002-4.83-1.035-9.098-3.124-12.761l-124.263 71.55 124.413 72.074c1.994-3.608 2.985-7.793 2.987-12.518 0 0 0-78.889-.013-118.345"></path><path fill="#FFF" d="M248.728 148.661h-9.722v9.724h-9.724v-9.724h-9.721v-9.721h9.721v-9.722h9.724v9.722h9.722v9.721M213.253 148.661h-9.721v9.724h-9.722v-9.724h-9.722v-9.721h9.722v-9.722h9.722v9.722h9.721v9.721"></path><path fill="#FFF" d="M164.619 164.616c-7.248 12.854-21.021 21.541-36.828 21.541-15.71 0-29.405-8.578-36.69-21.296a42.062 42.062 0 0 1-5.574-20.968c0-23.341 18.923-42.263 42.264-42.263 15.609 0 29.232 8.471 36.553 21.059l36.941-21.272c-14.683-25.346-42.096-42.398-73.494-42.398-46.876 0-84.875 38-84.875 84.874 0 15.378 4.091 29.799 11.241 42.238 14.646 25.48 42.137 42.637 73.634 42.637 31.555 0 59.089-17.226 73.714-42.781l-36.886-21.371"></path></svg>
              <h2 className="text-white mt-2">C++</h2>
            </div>



            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <g clip-path="url(#clip0_29_3)">
                  <path
                    d="M48.5849 0.0275879C23.7664 0.0275879 25.3161 10.7904 25.3161 10.7904L25.3436 21.9409H49.0275V25.2886H15.9368C15.9368 25.2886 0.0554199 23.4875 0.0554199 48.5292C0.0554199 73.5716 13.9171 72.6835 13.9171 72.6835H22.1896V61.0628C22.1896 61.0628 21.7437 47.2012 35.83 47.2012H59.3202C59.3202 47.2012 72.5176 47.4144 72.5176 34.4463V13.0042C72.5176 13.0042 74.522 0.0275879 48.5849 0.0275879ZM35.5257 7.52612C36.0853 7.52561 36.6396 7.63548 37.1568 7.84942C37.6739 8.06336 38.1438 8.37718 38.5396 8.77293C38.9353 9.16867 39.2491 9.63857 39.4631 10.1557C39.677 10.6729 39.7869 11.2272 39.7864 11.7868C39.7869 12.3465 39.677 12.9008 39.4631 13.4179C39.2491 13.9351 38.9353 14.405 38.5396 14.8007C38.1438 15.1965 37.6739 15.5103 37.1568 15.7242C36.6396 15.9382 36.0853 16.048 35.5257 16.0475C34.966 16.048 34.4117 15.9382 33.8946 15.7242C33.3774 15.5103 32.9075 15.1965 32.5118 14.8007C32.116 14.405 31.8022 13.9351 31.5883 13.4179C31.3743 12.9008 31.2645 12.3465 31.265 11.7868C31.2645 11.2272 31.3743 10.6729 31.5883 10.1557C31.8022 9.63857 32.116 9.16867 32.5118 8.77293C32.9075 8.37718 33.3774 8.06336 33.8946 7.84942C34.4117 7.63548 34.966 7.52561 35.5257 7.52612Z"
                    fill="url(#paint0_linear_29_3)"
                  />
                  <path
                    d="M49.2898 97.2826C74.1083 97.2826 72.5586 86.5198 72.5586 86.5198L72.5311 75.3696H48.8468V72.0219H81.9375C81.9375 72.0219 97.8189 73.8231 97.8189 48.7806C97.8189 23.7386 83.9573 24.6267 83.9573 24.6267H75.6847V36.247C75.6847 36.247 76.1307 50.1086 62.0443 50.1086H38.5542C38.5542 50.1086 25.3567 49.8954 25.3567 62.8639V84.3064C25.3567 84.3064 23.3527 97.2826 49.2894 97.2826H49.2898ZM62.349 89.7848C61.7894 89.7853 61.2351 89.6755 60.7179 89.4615C60.2008 89.2476 59.7309 88.9338 59.3351 88.538C58.9394 88.1423 58.6256 87.6724 58.4116 87.1552C58.1977 86.6381 58.0878 86.0838 58.0883 85.5241C58.0878 84.9644 58.1976 84.4101 58.4115 83.8929C58.6254 83.3757 58.9392 82.9058 59.335 82.51C59.7307 82.1142 60.2007 81.8003 60.7178 81.5864C61.235 81.3724 61.7893 81.2625 62.349 81.263C62.9087 81.2625 63.463 81.3724 63.9801 81.5863C64.4973 81.8003 64.9672 82.1141 65.3629 82.5098C65.7587 82.9056 66.0725 83.3755 66.2864 83.8926C66.5004 84.4098 66.6102 84.9641 66.6097 85.5237C66.6102 86.0834 66.5004 86.6377 66.2864 87.1548C66.0725 87.672 65.7587 88.1419 65.3629 88.5376C64.9672 88.9334 64.4973 89.2472 63.9801 89.4611C63.463 89.6751 62.9087 89.7853 62.349 89.7848Z"
                    fill="url(#paint1_linear_29_3)"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_29_3"
                    x1="939.559"
                    y1="874.779"
                    x2="5784.42"
                    y2="5671.3"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#387EB8" />
                    <stop offset="1" stop-color="#366994" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_29_3"
                    x1="1412.06"
                    y1="1519.89"
                    x2="6614.88"
                    y2="6438.28"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FFE052" />
                    <stop offset="1" stop-color="#FFC331" />
                  </linearGradient>
                  <clipPath id="clip0_29_3">
                    <rect width="98" height="97.6172" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">Python</h2>
            </div>

            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src={node} alt="Nodejs icon" />
              <h2 className="text-white mt-2">Node.JS</h2>
            </div>

            {/* <div className="python flex flex-col items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 128 128" id="node-js">
          <path fill="#83CD29" d="M114.325 80.749c-.29 0-.578-.076-.832-.224l-2.65-1.568c-.396-.221-.203-.3-.072-.345.528-.184.635-.227 1.198-.545.059-.033.136-.021.197.015l2.035 1.209c.074.041.179.041.246 0l7.937-4.581c.075-.042.122-.127.122-.215v-9.16c0-.09-.047-.173-.123-.219l-7.934-4.577c-.074-.042-.171-.042-.245 0l-7.933 4.578c-.076.045-.125.131-.125.218v9.16c0 .088.049.171.125.212l2.174 1.257c1.18.589 1.903-.105 1.903-.803v-9.045c0-.127.103-.228.23-.228h1.007c.125 0 .229.101.229.228v9.045c0 1.574-.857 2.477-2.35 2.477-.459 0-.82 0-1.828-.496l-2.081-1.198c-.515-.298-.832-.854-.832-1.448v-9.16c0-.595.317-1.15.832-1.446l7.937-4.587c.502-.283 1.169-.283 1.667 0l7.937 4.587c.514.297.833.852.833 1.446v9.16c0 .595-.319 1.148-.833 1.448l-7.937 4.582c-.252.147-.539.223-.834.223M116.778 74.438c-3.475 0-4.202-1.595-4.202-2.932 0-.126.103-.229.23-.229h1.026c.115 0 .21.082.228.194.154 1.045.617 1.572 2.718 1.572 1.671 0 2.383-.378 2.383-1.266 0-.512-.202-.891-2.8-1.146-2.172-.215-3.515-.694-3.515-2.433 0-1.601 1.35-2.557 3.612-2.557 2.543 0 3.801.883 3.96 2.777.006.064-.017.127-.06.176-.044.045-.104.073-.168.073h-1.031c-.107 0-.201-.075-.223-.179-.248-1.1-.848-1.451-2.479-1.451-1.825 0-2.037.637-2.037 1.112 0 .577.25.745 2.715 1.071 2.439.323 3.598.779 3.598 2.494.001 1.733-1.441 2.724-3.955 2.724M97.982 68.43c.313-.183.506-.517.506-.88v-2.354c0-.362-.192-.696-.506-.879l-8.364-4.856c-.315-.183-.703-.184-1.019-.002l-8.416 4.859c-.314.182-.508.517-.508.88v9.716c0 .365.196.703.514.884l8.363 4.765c.308.177.686.178.997.006l5.058-2.812c.161-.09.261-.258.262-.44.001-.184-.097-.354-.256-.445l-8.468-4.86c-.159-.091-.256-.259-.256-.44v-3.046c0-.182.097-.349.254-.439l2.637-1.52c.156-.091.35-.091.507 0l2.637 1.52c.158.091.255.258.255.439v2.396c0 .183.097.351.254.441.158.091.352.091.51-.001l5.039-2.932M88.984 67.974c.061-.034.135-.034.195 0l1.615.933c.06.035.097.1.097.169v1.865c0 .07-.037.134-.097.169l-1.615.932c-.06.035-.135.035-.195 0l-1.614-.932c-.061-.035-.098-.099-.098-.169v-1.865c0-.069.037-.134.098-.169l1.614-.933M67.083 71.854c0 .09-.048.174-.127.22l-2.89 1.666c-.079.046-.176.046-.254 0l-2.89-1.666c-.079-.046-.127-.13-.127-.22v-3.338c0-.09.049-.175.127-.221l2.89-1.668c.079-.047.176-.047.255 0l2.891 1.668c.078.046.126.131.126.221v3.338zm.781-24.716c-.157-.087-.349-.085-.505.006-.155.092-.251.258-.251.438v12.915c0 .126-.068.244-.177.308-.11.063-.246.063-.356 0l-2.108-1.215c-.314-.181-.701-.181-1.015 0l-8.418 4.858c-.315.182-.509.518-.509.881v9.719c0 .363.194.698.508.881l8.418 4.861c.314.182.702.182 1.017 0l8.42-4.861c.314-.183.508-.518.508-.881v-24.227c0-.368-.2-.708-.521-.888l-5.011-2.795M38.238 59.407c.314-.182.702-.182 1.016 0l8.418 4.857c.314.182.508.518.508.881v9.722c0 .363-.194.699-.508.881l-8.417 4.861c-.314.181-.702.181-1.017 0l-8.415-4.861c-.314-.182-.508-.518-.508-.881v-9.723c0-.362.194-.698.508-.88l8.415-4.857M22.93 65.064c0-.366-.192-.702-.508-.883l-8.415-4.843c-.144-.084-.303-.127-.464-.133h-.087c-.16.006-.32.049-.464.133l-8.416 4.843c-.313.181-.509.517-.509.883l.018 13.04c0 .182.095.351.254.439.156.094.349.094.505 0l5-2.864c.316-.188.509-.519.509-.882v-6.092c0-.364.192-.699.507-.881l2.13-1.226c.158-.093.332-.137.508-.137.174 0 .352.044.507.137l2.128 1.226c.315.182.509.517.509.881v6.092c0 .363.195.696.509.882l5 2.864c.157.094.353.094.508 0 .155-.089.252-.258.252-.439l.019-13.04"></path>
          </svg>
          <h2 className="text-white mt-2">Node.JS</h2>
          </div> */}

            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src={mongo} alt="MongoDB icon" />
              <h2 className="text-white mt-2">MongoDB</h2>
            </div>

            <div className="python flex flex-col items-center">
              <JavaIcon />
              <h2 className="text-white mt-2">Java</h2>
            </div>

            <div className="python flex flex-col items-center">
              <TypeScriptIcon />
              <h2 className="text-white mt-2">TypeScript</h2>
            </div>

            <div className="python flex flex-col items-center">
              <XmlIcon />
              <h2 className="text-white mt-2">XML</h2>
            </div>

            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src={odoo} alt="Odoo icon" />
              <h2 className="text-white mt-2">Odoo</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="mysql">
                <path fill="#105E86" d="M6.532 19.554c-.146 0-.276-.009-.386-.026v.485c.226.09.413.135.566.135.573 0 1.101-.35 1.583-1.053.616-.91 1.114-2.371 1.492-4.379h-.88a14.741 14.741 0 0 1-.835 3.419c.028-.209-.041-.576-.205-1.102l-.727-2.317h-.91l1.014 3.099c.153.465.23.775.23.927 0 .219-.098.417-.295.594-.164.144-.379.218-.647.218z"></path><path fill="#DE8A03" d="M19.482 13.293v5.429h2.63v-.668h-1.745v-4.761z"></path><path fill="#105E86" d="M1.04 14.392h.01l1.4 4.33h.705l1.41-4.33h.008a49.03 49.03 0 0 1 .27 4.33h.93a57.767 57.767 0 0 0-.428-5.429H4.25l-1.347 3.99h-.008l-1.335-3.99H.41A54.641 54.641 0 0 0 0 18.722h.845c.027-1.588.092-3.031.195-4.33z"></path><path fill="#DE8A03" d="M18.679 15.906c0-1.796-.718-2.696-2.155-2.696-.704 0-1.254.228-1.65.684-.43.499-.646 1.233-.646 2.204 0 .954.19 1.655.574 2.101.35.403.877.604 1.583.604.264 0 .506-.032.725-.096l1.325.758.36-.61h-.003l-1.016-.491c.09-.075.177-.155.255-.245.433-.498.648-1.236.648-2.213zm-2.203 2.225c-.445 0-.77-.164-.978-.491l.002-.005c-.225-.353-.337-.923-.337-1.704 0-1.368.424-2.052 1.27-2.052.443 0 .77.164.977.491.224.355.336.919.336 1.692 0 1.378-.424 2.069-1.27 2.069zM13.2 16.074s-.794-.447-1.187-.658c-.432-.236-.666-.513-.666-.834a.67.67 0 0 1 .248-.515c.152-.136.371-.202.654-.202.349 0 .704.076 1.064.226l.213-.467a2.544 2.544 0 0 0-1.4-.402c-.5 0-.905.134-1.22.407-.313.27-.47.623-.47 1.065 0 .531.21.854.632 1.156 0 0 .775.436 1.163.645.418.231.648.506.648.83a.737.737 0 0 1-.3.604c-.19.144-.451.216-.783.216-.357 0-.752-.106-1.19-.322l-.237.467c.509.337 1.03.506 1.573.506.581 0 1.04-.147 1.384-.442.344-.294.516-.673.516-1.135l.006.003c0-.529-.215-.848-.648-1.148z"></path><path fill="#105E86" d="M16.405 5.768c-.115 0-.193.014-.274.032v.013h.014c.054.102.146.177.214.268.054.105.1.21.154.314l.014-.015c.094-.065.14-.169.14-.327-.04-.046-.046-.092-.08-.137-.04-.066-.126-.098-.18-.15l-.002.002z"></path><path fill="#105E86" d="M23.695 13.2a3.215 3.215 0 0 0-.695-.663c-.214-.143-.682-.344-.77-.584l-.013-.014c.146-.013.32-.065.46-.104.227-.059.435-.046.67-.104.106-.026.213-.059.32-.092v-.059c-.12-.118-.21-.278-.334-.388a8.86 8.86 0 0 0-1.104-.808c-.21-.132-.476-.216-.697-.328-.08-.039-.214-.059-.26-.125-.12-.143-.19-.334-.275-.505-.192-.361-.38-.761-.547-1.142-.12-.257-.193-.513-.34-.749-.69-1.116-1.437-1.793-2.586-2.454-.247-.137-.543-.196-.856-.269-.167-.008-.334-.02-.5-.027-.11-.046-.216-.171-.31-.231-.38-.236-1.364-.746-1.644-.071-.18.426.267.846.422 1.062.115.15.26.322.34.491.047.114.06.231.107.35.106.289.207.61.347.881.073.137.153.282.247.405.054.072.146.105.167.223-.094.134-.1.328-.154.491-.24.743-.146 1.662.194 2.209.107.163.362.524.703.386.3-.118.234-.491.32-.82.02-.079.007-.131.048-.184v.015c.094.185.188.36.274.545.206.322.566.656.867.879.16.118.287.322.487.395v-.02h-.015c-.043-.057-.1-.084-.154-.131a3.384 3.384 0 0 1-.35-.393 8.58 8.58 0 0 1-.747-1.196c-.11-.206-.202-.428-.29-.631-.04-.078-.04-.196-.107-.236-.1.143-.247.268-.32.445-.127.283-.14.63-.188.992-.027.007-.014 0-.027.014-.214-.051-.287-.269-.367-.452-.2-.466-.233-1.215-.06-1.753.047-.137.247-.571.167-.703-.042-.125-.174-.196-.247-.297a2.444 2.444 0 0 1-.24-.419c-.16-.367-.24-.774-.414-1.141-.08-.17-.22-.348-.334-.504-.127-.177-.267-.301-.368-.511-.033-.072-.08-.191-.027-.269.014-.053.042-.074.094-.088.088-.071.335.022.422.061.247.098.455.19.662.328.094.065.195.189.315.222h.14c.214.046.455.014.655.072.355.112.675.275.962.452a5.885 5.885 0 0 1 2.085 2.244c.08.151.115.29.188.447.14.324.313.651.455.964.14.309.275.625.476.881.1.137.502.209.682.281.133.059.34.113.46.185.23.137.454.295.67.446.11.075.443.239.463.371-.535-.014-.95.039-1.297.185-.1.039-.26.039-.274.164.055.052.063.137.11.21.08.131.218.307.346.4.14.108.28.212.427.304.26.157.555.25.81.408.145.092.293.209.44.307.073.049.12.138.214.169V13.6c-.046-.059-.06-.144-.105-.21-.067-.066-.134-.125-.2-.19z"></path>
              </svg>
              <h2 className="text-white mt-2">MySQL</h2>
            </div>


            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <path
                  d="M17.7625 75.3375L18.2831 74.6117L42.8443 28.0188L42.8964 27.5257L32.0705 7.19072C31.8723 6.81886 31.5622 6.51874 31.184 6.3328C30.8059 6.14687 30.3789 6.08455 29.9633 6.15464C29.5478 6.22474 29.1649 6.42371 28.8687 6.72341C28.5725 7.02311 28.378 7.40836 28.3128 7.82466L17.7625 75.3375Z"
                  fill="#FFC24A"
                />
                <path
                  d="M18.0688 74.7863L18.4608 74.0206L42.7679 27.9116L31.9695 7.49701C31.7915 7.14198 31.5031 6.85421 31.1478 6.67681C30.7924 6.49941 30.3891 6.44193 29.9984 6.51298C29.6076 6.58403 29.2503 6.77979 28.9802 7.07092C28.71 7.36206 28.5414 7.7329 28.4997 8.12789L18.0688 74.7863Z"
                  fill="#FFA712"
                />
                <path
                  d="M50.7886 42.9056L58.8491 34.6369L50.7855 19.2601C50.608 18.9292 50.3441 18.6525 50.0219 18.4597C49.6997 18.2669 49.3312 18.165 48.9557 18.165C48.5802 18.165 48.2117 18.2669 47.8894 18.4597C47.5672 18.6525 47.3033 18.9292 47.1258 19.2601L42.8169 27.4737V28.175L50.7886 42.9056Z"
                  fill="#F4BD62"
                />
                <path
                  d="M50.6446 42.5687L58.4815 34.545L50.6446 19.6C50.5163 19.2765 50.2972 18.997 50.0137 18.7952C49.7302 18.5935 49.3943 18.478 49.0467 18.4628C48.699 18.4476 48.3544 18.5332 48.0543 18.7095C47.7542 18.8857 47.5115 19.145 47.3555 19.4561L43.0251 27.8136L42.8965 28.2393L50.6446 42.5687Z"
                  fill="#FFA50E"
                />
                <path
                  d="M17.7686 75.3405L18.0044 75.1017L18.8588 74.7556L50.2801 43.4507L50.6782 42.3666L42.8412 27.4277L17.7686 75.3405Z"
                  fill="#F6820C"
                />
                <path
                  d="M51.793 91.1277L80.2375 75.267L72.1096 25.2534C72.0513 24.9008 71.897 24.5711 71.6637 24.3005C71.4303 24.0298 71.1269 23.8287 70.7867 23.7193C70.4466 23.6098 70.0828 23.5961 69.7354 23.6798C69.388 23.7635 69.0704 23.9413 68.8174 24.1937L17.7625 75.3375L46.0385 91.1247C46.9176 91.6152 47.9075 91.8727 48.9142 91.8727C49.9209 91.8727 50.9108 91.6152 51.7899 91.1247"
                  fill="#FDE068"
                />
                <path
                  d="M79.9773 75.1354L71.9168 25.4984C71.9026 25.1612 71.7886 24.8357 71.5893 24.5633C71.3901 24.2909 71.1145 24.0837 70.7974 23.9679C70.4804 23.8522 70.1361 23.8331 69.8082 23.9131C69.4803 23.9931 69.1835 24.1686 68.9554 24.4173L18.0688 75.2426L46.0325 90.8613C46.9046 91.3478 47.8866 91.6032 48.8853 91.6032C49.8839 91.6032 50.8659 91.3478 51.738 90.8613L79.9773 75.1354Z"
                  fill="#FCCA3F"
                />
                <path
                  d="M51.793 90.65C50.9139 91.1405 49.9239 91.3981 48.9173 91.3981C47.9106 91.3981 46.9206 91.1405 46.0416 90.65L17.9952 75.0986L17.7625 75.3375L46.0385 91.1247C46.9176 91.6152 47.9075 91.8727 48.9142 91.8727C49.9209 91.8727 50.9108 91.6152 51.7899 91.1247L80.2375 75.2671L80.167 74.8383L51.793 90.65Z"
                  fill="#EEAB37"
                />
              </svg>
              <h2 className="text-white mt-2">Firebase</h2>
            </div>

            <div className="python flex flex-col items-center">
              <img className="w-20 mx-auto" src={aws} alt="AWS icon" />
              <h2 className="text-white mt-2">AWS</h2>
            </div>

            <div className="python flex flex-col items-center">
              <GcpIcon/>
              <h2 className="text-white mt-2">GCP</h2>
            </div>


          </div>
        </div>



        <div className="div-skill card mr-5 mt-5 mb-5">
          <h2 className="text-white text-lg py-5 px-5 lg:px-9 font-semibold lg:text-xl">
            Data Entry, Presentation, Resume, Git, IDE, Operating Systems
          </h2>
          <div className="flex justify-center flex-wrap">
            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <path
                  d="M57.973 52.9812L51.992 9.1875H51.5448C41.1032 9.20524 31.0932 13.356 23.7029 20.7325C16.3126 28.109 12.1432 38.1113 12.106 48.5529V49L57.973 52.9812Z"
                  fill="#ED6C47"
                />
                <path
                  d="M52.4391 9.1875H51.9919V49L71.9319 56.9625L91.8749 49V48.5529C91.8377 38.1118 87.6686 28.11 80.279 20.7336C72.8894 13.3572 62.8802 9.20605 52.4391 9.1875Z"
                  fill="#FF8F6B"
                />
                <path
                  d="M91.8749 49V49.4379C91.8361 59.881 87.6656 69.8842 80.2746 77.2619C72.8836 84.6397 62.873 88.7923 52.4299 88.8125H51.551C41.1084 88.7907 31.0987 84.6376 23.708 77.2602C16.3174 69.8827 12.1464 59.8805 12.106 49.4379V49H91.8749Z"
                  fill="#D35230"
                />
                <path
                  opacity="0.1"
                  d="M53.9857 28.7538V71.2337C53.9802 71.9565 53.7616 72.6616 53.3574 73.2608C52.9533 73.8599 52.3814 74.3267 51.7133 74.6025C51.2771 74.7863 50.8085 74.881 50.3352 74.8812H21.5201C20.9611 74.2399 20.4287 73.5758 19.9246 72.8906C14.8447 66.1285 12.1007 57.8985 12.106 49.441V48.5651C12.0964 40.9362 14.3296 33.4728 18.5281 27.1031C18.9634 26.4189 19.4294 25.7547 19.9246 25.1125H50.3352C51.2998 25.1189 52.2232 25.5043 52.9062 26.1855C53.5891 26.8668 53.9769 27.7892 53.9857 28.7538Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M51.992 30.7475V73.2275C51.9918 73.6988 51.8971 74.1654 51.7133 74.5995C51.437 75.267 50.9701 75.8382 50.3709 76.2418C49.7718 76.6454 49.0669 76.8635 48.3445 76.8688H23.3362C22.7053 76.2277 22.0999 75.5642 21.5201 74.8782C20.9611 74.2369 20.4287 73.5728 19.9245 72.8875C14.8447 66.1255 12.1007 57.8955 12.106 49.438V48.5621C12.097 40.9342 14.3302 33.472 18.528 27.1031H48.3415C49.3066 27.1096 50.2305 27.4954 50.9135 28.1773C51.5966 28.8592 51.984 29.7824 51.992 30.7475Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M51.992 30.7475V69.2462C51.9832 70.2108 51.5954 71.1333 50.9125 71.8145C50.2295 72.4957 49.3061 72.8811 48.3415 72.8875H19.9245C14.8447 66.1255 12.1007 57.8955 12.106 49.438V48.5621C12.097 40.9342 14.3302 33.472 18.528 27.1031H48.3415C49.3066 27.1096 50.2305 27.4954 50.9135 28.1773C51.5966 28.8592 51.984 29.7824 51.992 30.7475Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M49.9983 30.7475V69.2462C49.9895 70.2108 49.6017 71.1333 48.9188 71.8145C48.2358 72.4957 47.3124 72.8811 46.3478 72.8875H19.9245C14.8447 66.1255 12.1007 57.8955 12.106 49.438V48.5621C12.097 40.9342 14.3302 33.472 18.528 27.1031H46.3478C47.3129 27.1096 48.2368 27.4954 48.9199 28.1773C49.6029 28.8592 49.9903 29.7824 49.9983 30.7475Z"
                  fill="black"
                />
                <path
                  d="M9.78163 27.1032H46.3417C47.3102 27.1023 48.2394 27.4861 48.925 28.17C49.6107 28.8539 49.9968 29.7821 49.9984 30.7506V67.2495C49.9968 68.2179 49.6107 69.1461 48.925 69.8301C48.2394 70.514 47.3102 70.8977 46.3417 70.8969H9.78163C9.30198 70.8977 8.82687 70.804 8.38347 70.6211C7.94006 70.4382 7.53704 70.1697 7.19745 69.8309C6.85787 69.4922 6.58836 69.0899 6.40434 68.6469C6.22032 68.204 6.1254 67.7291 6.125 67.2495V30.7506C6.1254 30.2709 6.22032 29.7961 6.40434 29.3531C6.58836 28.9102 6.85787 28.5078 7.19745 28.1691C7.53704 27.8304 7.94006 27.5619 8.38347 27.379C8.82687 27.1961 9.30198 27.1023 9.78163 27.1032Z"
                  fill="url(#paint0_linear_31_17)"
                />
                <path
                  d="M28.4599 36.8358C30.8399 36.6757 33.1993 37.3659 35.1178 38.7835C35.9066 39.4857 36.525 40.3584 36.9262 41.3353C37.3274 42.3122 37.5007 43.3677 37.433 44.4216C37.4598 45.9062 37.0636 47.3677 36.2907 48.6356C35.5087 49.8831 34.3823 50.8776 33.0475 51.499C31.5224 52.2063 29.8559 52.5561 28.1751 52.5219H23.5415V61.0969H18.8069V36.8358H28.4599ZM23.5384 48.8163H27.6146C28.907 48.9094 30.1889 48.5272 31.2192 47.7413C31.6405 47.3395 31.9685 46.8501 32.1802 46.3078C32.3918 45.7654 32.482 45.1832 32.4442 44.6023C32.4442 41.9297 30.8874 40.5924 27.7739 40.5904H23.5384V48.8163Z"
                  fill="white"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_31_17"
                    x1="13.7629"
                    y1="24.2367"
                    x2="42.3605"
                    y2="73.7634"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#CA4C28" />
                    <stop offset="0.5" stop-color="#C5401E" />
                    <stop offset="1" stop-color="#B62F14" />
                  </linearGradient>
                </defs>
              </svg>
              <h2 className="text-white mt-2">MS PowerPoint</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <path
                  d="M88.2185 9.18751H29.7217C29.2423 9.1871 28.7675 9.28113 28.3245 9.46421C27.8814 9.64729 27.4788 9.91585 27.1395 10.2545C26.8002 10.5932 26.531 10.9954 26.3472 11.4382C26.1633 11.8809 26.0685 12.3556 26.0681 12.8349V29.0938L59.9669 39.0469L91.8751 29.0938V12.8349C91.8747 12.3553 91.7798 11.8804 91.5958 11.4375C91.4118 10.9945 91.1422 10.5922 90.8027 10.2535C90.4631 9.91473 90.0601 9.64623 89.6166 9.46333C89.1732 9.28043 88.6981 9.1867 88.2185 9.18751Z"
                  fill="#41A5EE"
                />
                <path
                  d="M91.8751 29.0938H26.0681V49L59.9669 54.9719L91.8751 49V29.0938Z"
                  fill="#2B7CD3"
                />
                <path
                  d="M26.0681 49V68.9062L57.9732 72.8875L91.8751 68.9062V49H26.0681Z"
                  fill="#185ABD"
                />
                <path
                  d="M29.7217 88.8125H88.2154C88.6953 88.8137 89.1708 88.7203 89.6145 88.5376C90.0583 88.3548 90.4617 88.0864 90.8016 87.7476C91.1415 87.4089 91.4113 87.0064 91.5955 86.5632C91.7797 86.1201 91.8747 85.645 91.8751 85.1651V68.9062H26.0681V85.1651C26.0685 85.6445 26.1633 86.1191 26.3472 86.5618C26.531 87.0046 26.8002 87.4068 27.1395 87.7455C27.4788 88.0842 27.8814 88.3527 28.3245 88.5358C28.7675 88.7189 29.2423 88.8129 29.7217 88.8125Z"
                  fill="#103F91"
                />
                <path
                  opacity="0.1"
                  d="M50.3292 25.1125H26.0681V74.8781H50.3292C51.296 74.8733 52.2219 74.4878 52.9063 73.805C53.5908 73.1223 53.9786 72.1974 53.9859 71.2307V28.7599C53.9786 27.7932 53.5908 26.8683 52.9063 26.1856C52.2219 25.5028 51.296 25.1173 50.3292 25.1125Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M48.3356 27.1031H26.0681V76.8688H48.3356C49.3023 76.864 50.2282 76.4784 50.9126 75.7957C51.5971 75.113 51.9849 74.188 51.9922 73.2213V30.7506C51.9849 29.7839 51.5971 28.8589 50.9126 28.1762C50.2282 27.4935 49.3023 27.108 48.3356 27.1031Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M48.3356 27.1031H26.0681V72.8875H48.3356C49.3023 72.8827 50.2282 72.4972 50.9126 71.8145C51.5971 71.1317 51.9849 70.2068 51.9922 69.2401V30.7506C51.9849 29.7839 51.5971 28.8589 50.9126 28.1762C50.2282 27.4935 49.3023 27.108 48.3356 27.1031Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M46.3419 27.1031H26.0681V72.8875H46.3419C47.3086 72.8827 48.2345 72.4972 48.9189 71.8145C49.6034 71.1317 49.9913 70.2068 49.9985 69.2401V30.7506C49.9913 29.7839 49.6034 28.8589 48.9189 28.1762C48.2345 27.4935 47.3086 27.108 46.3419 27.1031Z"
                  fill="black"
                />
                <path
                  d="M9.78163 27.1032H46.3417C47.3102 27.1023 48.2394 27.4861 48.925 28.17C49.6107 28.8539 49.9968 29.7821 49.9984 30.7506V67.2495C49.9968 68.2179 49.6107 69.1461 48.925 69.8301C48.2394 70.514 47.3102 70.8977 46.3417 70.8969H9.78163C9.30198 70.8977 8.82687 70.804 8.38347 70.6211C7.94006 70.4382 7.53704 70.1697 7.19745 69.8309C6.85787 69.4922 6.58836 69.0899 6.40434 68.6469C6.22032 68.204 6.1254 67.7291 6.125 67.2495V30.7506C6.1254 30.2709 6.22032 29.7961 6.40434 29.3531C6.58836 28.9102 6.85787 28.5078 7.19745 28.1691C7.53704 27.8304 7.94006 27.5619 8.38347 27.379C8.82687 27.1961 9.30198 27.1023 9.78163 27.1032Z"
                  fill="url(#paint0_linear_31_27)"
                />
                <path
                  d="M21.1312 55.0882C21.2016 55.6517 21.2506 56.1417 21.272 56.5613H21.3578C21.3884 56.1632 21.4558 55.6824 21.5568 55.1219C21.6579 54.5615 21.7467 54.0868 21.8294 53.6979L25.6729 37.1389H30.6463L34.6276 53.4498C34.8595 54.4587 35.0252 55.4818 35.1237 56.5123H35.1911C35.2642 55.5091 35.4023 54.5117 35.6045 53.5264L38.7865 37.1175H43.3098L37.7238 60.8457H32.4348L28.6465 45.1474C28.5363 44.6941 28.4117 44.1041 28.2729 43.3772C28.1341 42.6504 28.0483 42.1196 28.0157 41.7847H27.9513C27.9085 42.1706 27.8227 42.7433 27.6941 43.5028C27.5655 44.2654 27.4644 44.8258 27.3878 45.1933L23.8262 60.8549H18.4484L12.8318 37.1389H17.4255L20.8892 53.7316C20.9926 54.1794 21.0733 54.6322 21.1312 55.0882Z"
                  fill="white"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_31_27"
                    x1="13.7629"
                    y1="24.2367"
                    x2="42.3605"
                    y2="73.7634"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#2368C4" />
                    <stop offset="0.5" stop-color="#1A5DBE" />
                    <stop offset="1" stop-color="#1146AC" />
                  </linearGradient>
                </defs>
              </svg>
              <h2 className="text-white mt-2">MS Word</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <path
                  d="M59.9668 47.0094L26.068 41.0375V85.165C26.0684 85.6444 26.1632 86.119 26.347 86.5618C26.5309 87.0045 26.8001 87.4067 27.1394 87.7454C27.4786 88.0841 27.8813 88.3527 28.3243 88.5358C28.7674 88.7189 29.2422 88.8129 29.7216 88.8125H88.2153C88.6952 88.8137 89.1706 88.7203 89.6144 88.5375C90.0582 88.3548 90.4615 88.0864 90.8015 87.7476C91.1414 87.4088 91.4111 87.0064 91.5954 86.5632C91.7796 86.1201 91.8746 85.6449 91.875 85.165V68.9062L59.9668 47.0094Z"
                  fill="#185C37"
                />
                <path
                  d="M59.9668 9.1875H29.7216C29.2422 9.1871 28.7674 9.28112 28.3243 9.46421C27.8813 9.64729 27.4786 9.91585 27.1394 10.2545C26.8001 10.5932 26.5309 10.9954 26.347 11.4382C26.1632 11.8809 26.0684 12.3555 26.068 12.8349V29.0938L59.9668 49L77.9161 54.9719L91.875 49V29.0938L59.9668 9.1875Z"
                  fill="#21A366"
                />
                <path
                  d="M26.068 29.0938H59.9668V49H26.068V29.0938Z"
                  fill="#107C41"
                />
                <path
                  opacity="0.1"
                  d="M50.3291 25.1125H26.068V74.8781H50.3291C51.2958 74.8733 52.2217 74.4878 52.9062 73.805C53.5906 73.1223 53.9785 72.1974 53.9857 71.2307V28.7599C53.9785 27.7932 53.5906 26.8683 52.9062 26.1856C52.2217 25.5028 51.2958 25.1173 50.3291 25.1125Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M48.3354 27.1031H26.068V76.8688H48.3354C49.3022 76.864 50.2281 76.4784 50.9125 75.7957C51.597 75.113 51.9848 74.188 51.9921 73.2213V30.7506C51.9848 29.7839 51.597 28.8589 50.9125 28.1762C50.2281 27.4935 49.3022 27.108 48.3354 27.1031Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M48.3354 27.1031H26.068V72.8875H48.3354C49.3022 72.8827 50.2281 72.4972 50.9125 71.8145C51.597 71.1317 51.9848 70.2068 51.9921 69.2401V30.7506C51.9848 29.7839 51.597 28.8589 50.9125 28.1762C50.2281 27.4935 49.3022 27.108 48.3354 27.1031Z"
                  fill="black"
                />
                <path
                  opacity="0.2"
                  d="M46.3417 27.1031H26.068V72.8875H46.3417C47.3085 72.8827 48.2344 72.4972 48.9188 71.8145C49.6033 71.1317 49.9911 70.2068 49.9984 69.2401V30.7506C49.9911 29.7839 49.6033 28.8589 48.9188 28.1762C48.2344 27.4935 47.3085 27.108 46.3417 27.1031Z"
                  fill="black"
                />
                <path
                  d="M9.78163 27.1032H46.3417C47.3102 27.1023 48.2394 27.4861 48.925 28.17C49.6107 28.8539 49.9968 29.7821 49.9984 30.7506V67.2495C49.9968 68.2179 49.6107 69.1461 48.925 69.8301C48.2394 70.514 47.3102 70.8977 46.3417 70.8969H9.78163C9.30198 70.8977 8.82687 70.804 8.38347 70.6211C7.94006 70.4382 7.53704 70.1697 7.19745 69.8309C6.85787 69.4922 6.58836 69.0899 6.40434 68.6469C6.22032 68.204 6.1254 67.7291 6.125 67.2495V30.7506C6.1254 30.2709 6.22032 29.7961 6.40434 29.3531C6.58836 28.9102 6.85787 28.5078 7.19745 28.1691C7.53704 27.8304 7.94006 27.5619 8.38347 27.379C8.82687 27.1961 9.30198 27.1023 9.78163 27.1032Z"
                  fill="url(#paint0_linear_31_38)"
                />
                <path
                  d="M17.4563 60.861L25.1462 48.9663L18.1025 37.1389H23.7589L27.6024 44.7125C27.9576 45.4291 28.2149 45.962 28.3312 46.3172H28.3833C28.6344 45.7415 28.9009 45.1872 29.1795 44.6451L33.2894 37.1512H38.4957L31.2712 48.9112L38.6794 60.8702H33.1394L28.6987 52.5678C28.4926 52.2108 28.3173 51.8369 28.175 51.45H28.1015C27.9721 51.8269 27.7994 52.1876 27.5871 52.5249L23.0147 60.861H17.4563Z"
                  fill="white"
                />
                <path
                  d="M88.2184 9.18751H59.9668V29.0938H91.875V12.8349C91.8746 12.3553 91.7797 11.8804 91.5956 11.4375C91.4116 10.9945 91.1421 10.5922 90.8025 10.2535C90.4629 9.91473 90.0599 9.64623 89.6165 9.46333C89.1731 9.28043 88.698 9.1867 88.2184 9.18751Z"
                  fill="#33C481"
                />
                <path
                  d="M59.9668 49H91.875V68.9062H59.9668V49Z"
                  fill="#107C41"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_31_38"
                    x1="13.7629"
                    y1="24.2367"
                    x2="42.3605"
                    y2="73.7634"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#18884F" />
                    <stop offset="0.5" stop-color="#117E43" />
                    <stop offset="1" stop-color="#0B6631" />
                  </linearGradient>
                </defs>
              </svg>
              <h2 className="text-white mt-2">MS Excel</h2>
            </div>

            <div className="python flex flex-col items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 98 98"
                fill="none"
              >
                <g clip-path="url(#clip0_3_2)">
                  <path
                    d="M95.5018 44.6957L53.3036 2.499C50.875 0.0689064 46.9336 0.0689064 44.5012 2.499L35.7394 11.2623L46.8547 22.3777C49.4387 21.5056 52.4001 22.0906 54.4589 24.1493C56.5284 26.2211 57.1087 29.2078 56.2153 31.8002L66.9279 42.5136C69.5195 41.6201 72.5108 42.1974 74.5795 44.2707C77.4736 47.1625 77.4736 51.8504 74.5795 54.7437C73.8918 55.4318 73.0752 55.9776 72.1764 56.35C71.2777 56.7224 70.3144 56.9141 69.3415 56.9141C68.3686 56.9141 67.4053 56.7224 66.5066 56.35C65.6078 55.9776 64.7912 55.4318 64.1035 54.7437C63.0702 53.7098 62.3658 52.3933 62.0791 50.96C61.7923 49.5266 61.9359 48.0405 62.4918 46.6886L52.502 36.6987L52.5004 62.991C53.2252 63.348 53.887 63.8207 54.4597 64.3906C57.3522 67.2824 57.3522 71.9688 54.4597 74.8666C51.5664 77.7584 46.8769 77.7584 43.9867 74.8666C41.0942 71.9695 41.0942 67.2831 43.9867 64.3906C44.6797 63.6965 45.504 63.1473 46.4114 62.7751V36.2393C45.5032 35.8682 44.6787 35.3186 43.9867 34.6231C41.7955 32.4334 41.268 29.2178 42.3919 26.5258L31.4335 15.5675L2.499 44.5004C1.33166 45.6681 0.675893 47.2516 0.675893 48.9028C0.675893 50.5539 1.33166 52.1374 2.499 53.3051L44.698 95.5018C47.128 97.9319 51.068 97.9319 53.5019 95.5018L95.5025 53.5011C96.6696 52.3331 97.3251 50.7494 97.325 49.0982C97.3249 47.447 96.6691 45.8635 95.5018 44.6957Z"
                    fill="#F34F29"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3_2">
                    <rect width="98" height="98" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <h2 className="text-white mt-2">Git</h2>
            </div>

            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src={Github} alt="GITHUB icon" />
              <h2 className="text-white mt-2">GitHub</h2>
            </div>

            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src="https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg" alt="VS Code" />
              <h2 className="text-white mt-2">VS Code</h2>
            </div>
            <div className="python flex flex-col items-center">
              <img className='w-20 mx-auto' src="https://upload.wikimedia.org/wikipedia/commons/1/1d/PyCharm_Icon.svg" alt="PyCharm" />
              <h2 className="text-white mt-2">PyCharm</h2>
            </div>
            <div className="python flex flex-col items-center">
              <CursorIcon />
              <h2 className="text-white mt-2">Cursor</h2>
            </div>
            
            <div className="python flex flex-col items-center object-cover overflow-hidden">
              <img className='w-30 mx-auto' src={docker} alt="Docker icon" />
              <h2 className="text-white mt-2">Docker</h2>
            </div>

            <div className="python flex flex-col items-center object-cover overflow-hidden">
              <KubernetesIcon />
              <h2 className="text-white mt-2">Kubernetes</h2>
            </div>

            <div className="python flex flex-col items-center">
              <WindowsIcon />
              <h2 className="text-white mt-2">WindowsOS</h2>
            </div>

            <div className="python flex flex-col items-center">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/c/c9/Finder_Icon_macOS_Big_Sur.png"
                alt="Mac OS"
              />
              <h2 className="text-white mt-2">macOS</h2>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default Skills;
